import { createContext } from 'react';

/*
  Holds the create-account wizard's Tier selection (BT-9734) at the stable Model level, above the
  Step-2 subtree. The billed "details" step (BilledAccountDetails) is keyed + conditionally
  unmounted, so it remounts on every Back→Next. Keeping the selected tier in local field state
  would reset it on remount and silently revert a deliberately-chosen tier to the default. Lifting
  it here lets TierSelectField stay a dumb controlled consumer while the choice persists.

  Value: { tiers: TierDto[], selectedTierId: string, setSelectedTierId: (v: string) => void, isLoading: boolean }.
  The default is a harmless no-op so TierSelectField can't crash if ever rendered outside a provider.
*/
export const TierSelectionContext = createContext({
  tiers: [],
  selectedTierId: '',
  setSelectedTierId: () => {},
  isLoading: false,
});
